import { observable, action, computed, toJS } from "mobx";

import getLocale from "../utils/locale";

const WHITELIST = [
  "en-us",
  "en-US",
  "pt-br",
  "pt-BR",
  "fr-fr",
  "fr-FR",
  "sv-se",
  "sv-SE"
];

let LOCALE =
  (navigator.languages && navigator.languages[0]) ||
  navigator.language ||
  navigator.userLanguage;

class Ui {
  constructor() {
    this.setLocale(getLocale());
  }

  theme = observable.box("main");

  locale = observable.box("en-us");

  setTheme = action(theme => this.theme.set(theme));

  setLocale = action((locale = getLocale()) => {
    if (locale === "pt-br") document.querySelector("html").lang = "pt-BR";
    else if (locale === "fr-fr") document.querySelector("html").lang = "fr-FR";
    else if (locale === "sv-se") document.querySelector("html").lang = "sv-SE";
    else document.querySelector("html").lang = "en-US";

    this.locale.set(locale);
  });

  getTheme = computed(() => toJS(this.theme.get()));

  getLocale = computed(() => toJS(this.locale.get()));
}

export default new Ui();



// WEBPACK FOOTER //
// ./src/stores/ui.js